interface HeroStat {
  label: string;
  value: string | number;
  sublabel: string;
  color?: string;
}

export function HeroStats({ stats }: { stats: HeroStat[] }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {stats.map((s) => (
        <div
          key={s.label}
          className="rounded-lg border border-border bg-surface p-4"
        >
          <div className="text-[10px] uppercase tracking-wider text-muted-foreground">
            {s.label}
          </div>
          <div
            className={`mt-1 text-2xl font-bold ${s.color ?? "text-foreground"}`}
          >
            {s.value}
          </div>
          <div className="text-[10px] text-muted-foreground">{s.sublabel}</div>
        </div>
      ))}
    </div>
  );
}
